<template>
  <div class="PCHomeTab1-box">
    <!-- <div class="img-box">
      <img src="https://mediakit.enabot.com/eboX/img/pc/protectorTopImg.png" alt="">
    </div> -->
    <div class="title-text-box">
      <div class="title-text">Home is where EBO starts from.</div>
      <div class="describe">
        The powerful X3M chip, based on a speedup processing dual-core BPU, coupled with tens of thousands of hours of
        training data, makes EBO X the most intelligent moving homebot.
      </div>
    </div>
    <!-- <div style="marginBottom: 120px;">
      
    </div> -->
    <!-- <vue-lazy-component tagName="div" :timeout="4000">
      <SmartMappingHome />
      <SelefBalanced />
      <StablizedCamera />
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="5000">
      <EdgeDetection />
      <AutoBackToCharge />
      <FixedLocation />
    </vue-lazy-component> -->
    <SmartMappingHome />
    <SelefBalanced />
    <StablizedCamera />
    <EdgeDetection />
    <AutoBackToCharge />
    <FixedLocation />
    <div class="mainPart">
      <!-- <div class="imgbox-1">
        <div class="imgBox1-left">
          <div class="top-img">
            <img src="https://mediakit.enabot.com/eboX/img/pc/AlertImg.png" alt="">
          </div>
          <span>
            If your child is crying, EBO X will detect it and trigger an App call to you. Besides, EBO X will inform you
            through the App call if anyone at home is experiencing an emergency and calls for help.
          </span>
          <div>
            *Effective distance = 3-5 meters.
          </div>
        </div>
        <div class="imgBox1-right">
          <img src="https://mediakit.enabot.com/eboX/img/pc/mainPart1.png" alt="">
        </div>
      </div> -->
      <div class="imgbox-1">
        <div class="imgBox1-left">
          <!-- <img src="https://mediakit.enabot.com/eboX/img/pc/mainPart1.png" alt=""> -->
          <video preload="auto"  autoplay muted loop src="https://mediakit.enabot.com/eboX/video/elderly-fall-alert.mp4"></video>
        </div>
        <div class="imgBox1-right">
          <div class="top-img">
            <img src="https://mediakit.enabot.com/eboX/img/pc/AlertImg.png" alt="">
          </div>
          <span>
            EBO X can be set to detect the fall-down of an elderly during auto-cruising. lf detected, it will send alerts through 3 optional ways to ask for help.
          </span>
          <!-- <div>
            *Facial recognition function requires saving face information in advance.
          </div> -->
        </div>
      </div>
      
      <div class="imgbox-3">
        <div class="imgBox3-left">
          <div class="top-img">
            <img src="https://mediakit.enabot.com/eboX/img/pc/mainPart4.png" alt="">
          </div>
          <span>
            If your child is crying, EBO X will detect it and trigger an App call to you. Besides, EBO X will inform you
            through the App call if anyone at home is experiencing an emergency and calls for help.
          </span>
          <div>
            *Effective distance = 3-5 meters.
          </div>
        </div>
        <div class="imgBox3-right"  v-lazy-container="{ selector: 'img' }">
          <img  data-src="https://mediakit.enabot.com/eboX/img/pc/mainPart5.png" alt="">
        </div>
      </div>
      <div class="imgbox-2">
        <div class="imgBox2-left">
          <video preload="auto" autoplay muted loop src="https://mediakit.enabot.com/eboX/video/facial-recognition-medication-reminder.mp4"></video>
        </div>
        <div class="imgBox2-right">
          <div class="top-img">
            <img src="https://mediakit.enabot.com/eboX/img/pc/mainPart3.png" alt="">
          </div>
          <span>
            Even if you don't live with your elderly loved ones, you can still take care of them. Just set a
            new“Medication Reminder”task for EBO X in the App. At a scheduled time, EBO X can find the specific family
            member by facial recognition, and send the medication reminders in voice.
          </span>
          <div>
            *Facial recognition function requires saving face information in advance.
          </div>
        </div>
      </div>
      <div>
        <CertainAreasIntrusionAlert />
      </div>
      
<!--       
      <RealTimeTwoWay />
      <BringAlexaToYou /> -->
    </div>
  </div>
</template>
<script>
import SmartMappingHome from './smartMappingHome'
import SelefBalanced from './selefBalanced'
import StablizedCamera from './stablizedCamera'
import EdgeDetection from './edgeDetection'
import AutoBackToCharge from './autoBackToCharge'
import FixedLocation from './fixedLocation'

// import BringAlexaToYou from './bringAlexaToYou'
// import realTimeTwoWay from './realTimeTwoWay'
import CertainAreasIntrusionAlert from './certainAreasIntrusionAlert'
import ElderlyFallAlert from './elderlyFallAlert'
export default {
  components:{
    SmartMappingHome,
    SelefBalanced,

    EdgeDetection,
    AutoBackToCharge,
    FixedLocation,

    // RealTimeTwoWay,
    StablizedCamera,
    CertainAreasIntrusionAlert,
    ElderlyFallAlert
  },
  data() {
    return {
      list: [
        { img: "https://mediakit.enabot.com/eboX/img/pc/Family.png", text: "Your Family's Protector" },
        { img: 'https://mediakit.enabot.com/eboX/img/pc/Family1.png', text: "Your Family's Companion" },
        { img: 'https://mediakit.enabot.com/eboX/img/pc/Family2.png', text: "Your Family's Playmate" },
      ],
    }
  },
}
</script>
<style lang="scss" scoped>
.PCHomeTab1-box {
  background: #040D32;
  // padding-bottom: 120px;

  .img-box {
    width: 100%;
    margin-bottom: 115px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .title-text-box {
    width: 715px;
    margin: 0 auto;
    // margin-bottom: 105px;

    .title-text {
      font-size: 32px;
      font-family: Public Sans;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 32px;
      margin-bottom: 25px;
    }

    .describe {
      font-size: 16px;
      // font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
    }

  }

  .alert-title {
    height: 58px;
    width: 450px;
    margin: 0 auto;
    margin-bottom: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .alert-describe {
    margin: 0 auto;
    width: 750px;
    font-size: 16px;
    // font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .mainPart {
    max-width: 1200px;
    margin: 120px auto 0;
    // overflow: hidden;
    // background-color: red;
    
    .imgbox-1{
      height: 338px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 122px;

      .imgBox1-left {
        width: 50%;

        video,img {
          width: 100%;
          height: 100%;
        }
      }

      .imgBox1-right {
        width: 47%;
        text-align: left;
        padding-top: 102px;

        .top-img {
          max-width: 450px;
          height: auto;
          margin-bottom: 31px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        span {
          display: block;
          height: 77px;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          margin-bottom: 32px;
          max-width: 510px;
        }

        div {
          height: 12px;
          font-size: 14px;
          font-family: Arial;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 12px;
        }
      }
    }
    .imgbox-2 {
      height: 338px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 122px;

      .imgBox2-left {
        width: 50%;

        video,img {
          width: 100%;
          height: auto;
          // background: red;
        }
      }

      .imgBox2-right {
        width: 47%;
        text-align: left;
        padding-top: 36px;

        .top-img {
          height: 112px;
          margin-bottom: 31px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        span {
          display: block;
          height: 77px;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          margin-bottom: 32px;
        }

        div {
          height: 12px;
          font-size: 14px;
          font-family: Arial;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 12px;
        }
      }

    }

    .imgbox-3 {
      height: 338px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 119px;

      .imgBox3-right {
        width: 600px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .imgBox3-left {
        width: 544px;
        text-align: left;
        padding-top: 36px;

        .top-img {
          height: 123px;
          width: 499px;
          margin-bottom: 29px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        span {
          display: block;
          height: 57px;
          font-size: 15px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          margin-bottom: 33px;
        }

        div {
          height: 12px;
          font-size: 14px;
          font-family: Arial;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 12px;
        }
      }

    }
    .QRcode{
      width: 207px;
      height: 207px;
      margin: 0 auto;
      margin-top: 118px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .join-box{
      width: 319px;
      height: 64px;
      margin: 0 auto;
      border-radius: 64px;
      background: url("../../../assets/pc/btnBack.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 64px;
      margin-top: 24px;
    }
  }
  .Explore-box{
    height: 151px;
    img{
      width: 100%;
      height: 100%;
      margin-top: 120px;
    }
  }
}
</style>